import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Twitter } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { language } = useLanguage();

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_innovate-nexus-1/artifacts/hxel7nka_BRAND2020_1.png"
              alt="ColaboraChile"
              className="h-10 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm">
              {language === 'es'
                ? 'Plataforma que conecta desafios de innovacion con soluciones del ecosistema nacional.'
                : 'Platform connecting innovation challenges with solutions from the national ecosystem.'}
            </p>
          </div>

          {/* Plataforma */}
          <div>
            <h3 className="font-semibold mb-4">
              {language === 'es' ? 'Plataforma' : 'Platform'}
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/programs" className="text-gray-400 hover:text-white transition-colors">
                  {language === 'es' ? 'Explorar Desafíos' : 'Browse Challenges'}
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-400 hover:text-white transition-colors">
                  {language === 'es' ? 'Precios' : 'Pricing'}
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-gray-400 hover:text-white transition-colors">
                  {language === 'es' ? 'Registrarse' : 'Sign Up'}
                </Link>
              </li>
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h3 className="font-semibold mb-4">
              {language === 'es' ? 'Empresa' : 'Company'}
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/page/about" className="text-gray-400 hover:text-white transition-colors">
                  {language === 'es' ? 'Acerca de' : 'About Us'}
                </Link>
              </li>
              <li>
                <Link to="/founders" className="text-gray-400 hover:text-white transition-colors">
                  {language === 'es' ? 'Quienes Somos' : 'Who We Are'}
                </Link>
              </li>
              <li>
                <Link to="/page/contact" className="text-gray-400 hover:text-white transition-colors">
                  {language === 'es' ? 'Contacto' : 'Contact'}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/page/privacy" className="text-gray-400 hover:text-white transition-colors">
                  {language === 'es' ? 'Politica de Privacidad' : 'Privacy Policy'}
                </Link>
              </li>
              <li>
                <Link to="/page/terms" className="text-gray-400 hover:text-white transition-colors">
                  {language === 'es' ? 'Terminos de Servicio' : 'Terms of Service'}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} ColaboraChile. {language === 'es' ? 'Todos los derechos reservados.' : 'All rights reserved.'}
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Twitter">
              <Twitter className="w-5 h-5" />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn">
              <Linkedin className="w-5 h-5" />
            </a>
            <a href="mailto:contacto@colaborachile.cl" className="text-gray-400 hover:text-white transition-colors" aria-label="Email">
              <Mail className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
